import { render, staticRenderFns } from "./favorites_hint.vue?vue&type=template&id=03878953&scoped=true&"
import script from "./favorites_hint.vue?vue&type=script&lang=js&"
export * from "./favorites_hint.vue?vue&type=script&lang=js&"
import style0 from "./favorites_hint.vue?vue&type=style&index=0&id=03878953&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03878953",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03878953', component.options)
    } else {
      api.reload('03878953', component.options)
    }
    module.hot.accept("./favorites_hint.vue?vue&type=template&id=03878953&scoped=true&", function () {
      api.rerender('03878953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/favorites/favorites_hint.vue"
export default component.exports